import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  ManageAdminApiSecretsRootParamList,
  SettingsRootParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { ManageAdminApiSecretsScreen } from "./ManageAdminApiSecretsScreen";
import { CreateAdminApiSecretScreen } from "./CreateAdminApiSecretScreen";
import { ViewAdminApiSecretScreen } from "./ViewAdminApiSecretScreen";

const Stack = createStackHeaderNavigator<ManageAdminApiSecretsRootParamList>();

export interface ManageAdminApiSecretsRootScreenProps
  extends StackScreenProps<
    SettingsRootParamList,
    "ManageAdminApiSecretsRootScreen"
  > {}

export const ManageAdminApiSecretsRootScreen =
  ({}: ManageAdminApiSecretsRootScreenProps) => {
    return (
      <Stack.Navigator
        screenOptions={{
          animationEnabled: true,
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Group
          screenOptions={{
            title: "",
            headerLeft: () => <ModalCloseButton type="Back" />,
          }}
        >
          <Stack.Screen
            name="ManageAdminApiSecretsScreen"
            component={ManageAdminApiSecretsScreen}
          />
          <Stack.Screen
            name="CreateAdminApiSecretScreen"
            component={CreateAdminApiSecretScreen}
            options={{
              headerShown: true,
              title: "",
            }}
          />
          <Stack.Screen
            name="ViewAdminApiSecretScreen"
            component={ViewAdminApiSecretScreen}
            options={{
              headerShown: true,
              title: "",
            }}
          />
        </Stack.Group>
      </Stack.Navigator>
    );
  };
